import { render, staticRenderFns } from "./CustomerAnnouncements.vue?vue&type=template&id=b84cef64&"
import script from "./CustomerAnnouncements.vue?vue&type=script&lang=js&"
export * from "./CustomerAnnouncements.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAnnouncements.vue?vue&type=style&index=0&id=b84cef64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports